"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
exports.hexToRgb = function (hex) {
    if (/^#/.test(hex)) {
        hex = hex.slice(1);
    }
    if (hex.length !== 3 && hex.length !== 6) {
        throw new Error('Modular System Error -> Invaild hex string');
    }
    var digit = hex.split('');
    if (digit.length === 3) {
        digit = [digit[0], digit[0], digit[1], digit[1], digit[2], digit[2]];
    }
    var r = parseInt([digit[0], digit[1]].join(''), 16);
    var g = parseInt([digit[4], digit[5]].join(''), 16);
    var b = parseInt([digit[2], digit[3]].join(''), 16);
    return [r, g, b];
};
//# sourceMappingURL=hexToRgb.js.map